// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'
// Import the functions you need from the SDKs you need
// Your web app's Firebase configuration
// Import the functions you need from the SDKs you need


/// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD-6NeZey3ryJI1MN4W_poOZOLGyqqFf-A",
  authDomain: "eduvibe-b28cd.firebaseapp.com",
  projectId: "eduvibe-b28cd",
  storageBucket: "eduvibe-b28cd.appspot.com",
  messagingSenderId: "602902651147",
  appId: "1:602902651147:web:eb8b64b7adfed3bdf3c20e"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;